<template>
  <div class="container overflow-hidden">
    <b-link
      class="font-weight-bold d-block text-nowrap mr-3 mb-2"
      @click="mudarComponente()"
    >
      <el-button
        id="voltar-lista-chat-fluxo"
        style="border: none; background-color: transparent;"
        type="button"
        class="is-plain"
      >
        <i class="el-icon-back" />
        Fluxos
      </el-button>
    </b-link>
    <div class="row gx-5n mt-2">
      <div class="card col-12">

        <b-tabs
          pills
          align="start"
          @input="Listavariaveis"
        >
          <b-tab
            title="Personalize"
            active
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'design')"
          >
            <b-card-text style="margin-top: 80px">

              <div class="row">
                <div
                  class="col-8"
                  style="display: flex;justify-content: start;gap: 9px;align-items: center;"
                >
                  <h2
                    style="
    font-size: 28px;
"
                  >Chat</h2>
                  <b-form-checkbox
                    v-model="chat.status"
                    :checked="chat.status"
                    type="checkbox"
                    class="custom-control-success"
                    name="check-button"
                    switch
                    inline
                    @change="changeStatus(chat)"
                  />

                </div>

              </div>

              <div class="form-group mt-2">
                <label for="nome-chat-fluxo">Nome:</label>
                <input
                  id="nome-chat-fluxo"
                  v-model="chat.name"
                  type="text"
                  class="form-control"
                >
              </div>
              <div class="form-group">
                <label for="title2">Chamada Inicial:</label>
                <div id="chamada-inicial-fluxo">
                  <Info
                    :id="`chamada_inicial_${chat.id}`"
                    :message="chat.chamadaInicial"
                    indice="chamada_inteligente"
                    @atualizarMessage="updatedMessageInical($event)"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="title">Email para receber as informações dos leads:</label>

                <input
                  id="email-chat-fluxo"
                  v-model="chat.Email"
                  type="email"
                  class="form-control"
                  :disabled="chat.email_condicional_status === 1 || chat.email_condicional_status === '1'"
                >
              </div>

              <div>

                <div id="email-condicional-email-chat-fluxo">

                  <b-form-group label="Deseja habilita a opção de email condicional:">
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      v-b-tooltip.hover.right="'Caso selecionado sim, você poderá cadastrar emails com a condição que desejar.'"
                      variant="secondary"
                      size="sm"
                      style="margin-left: 321px;margin-top: -50px;"
                    >?
                    </b-button>
                    <b-form-checkbox-group

                      v-model="chat.email_condicional_status"
                      :checked="chat.email_condicional_status"
                      value="1"
                      unchecked-value="0"
                      :options="[{ text: 'Sim', value: '1' }, { text: 'Não', value: '0' }]"
                    />
                  </b-form-group>
                </div>
                <div
                  v-show="chat.email_condicional_status === 1 || chat.email_condicional_status === '1'"
                >
                  <b-form
                    ref="formEmail"
                    :style="{height: trHeight}"
                    class="repeater-form"
                    @submit.prevent="repeateAgain"
                  >
                    <b-row
                      v-for="(item, index) in items"
                      :id="item.id"
                      :key="item.id"
                      ref="row"
                    >
                      <b-col md="2">
                        <b-form-group
                          label="Variavel"
                          label-for="cost"
                        >
                          <v-select
                            v-model="item.variavel"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="label"
                            :options="variaveis"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                          label="Condição"
                          label-for="cost"
                        >
                          <v-select
                            v-model="item.condicao"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="title"
                            :options="condicao"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                          label="Valor"
                          label-for="quantity"
                        >

                          <v-select
                            v-model="item.valor"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="name"
                            :options=" item.variavel.options "
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="item.valor != null && item.variavel != null && item.condicao != null"
                        md="4"
                      >
                        <b-form-group
                          label="Email"
                          label-for="h-email"
                        >
                          <b-form-input

                            v-model="item.email"
                            type="email"
                            placeholder="Email"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        lg="2"
                        md="3"
                        class="mb-50"
                      >
                        <b-button
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="mt-0 mt-md-2"
                          @click="removeItem(index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="mr-25"
                          />
                          <span>Excluir</span>
                        </b-button>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                      </b-col>
                    </b-row>

                  </b-form>
                </div>
                <div
                  v-show="chat.email_condicional_status === 1 || chat.email_condicional_status === '1'"
                  class="mt-2"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>Novo</span>
                  </b-button>
                </div>
              </div>
              <div class="row mt-4">
                <div
                  class="col-8"
                  style="display: flex;justify-content: start;gap: 9px;align-items: center;"
                >
                  <h2
                    style="font-size: 28px;"
                  >Personalização de Páginas e Campanhas</h2>

                </div>
                <div class="form-group">
                  <label for="title">Domínio:</label>
                  <input
                    id="title"
                    v-model="getDomainChateByRole"
                    :disabled="getUserData.user_role === 'admin' ? false : true"
                    type="text"
                    class="form-control"
                  >
                </div>

              </div>

              <b-form-group label="Exibir esse fluxo em todas as páginas do site:">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-tooltip.hover.right="'Caso selecionado sim, seu chat aparecera em todas as paginas, quando selecionado não aparecera apenas na url definida ou palavra chave.'"
                  variant="secondary"
                  size="sm"
                  style="margin-left: 321px;margin-top: -50px;"
                >?
                </b-button>
                <b-form-checkbox-group
                  v-model="chat.is_trigger"
                  :checked="chat.is_trigger"
                  :options="[{ text: 'Sim', value: '0' }, { text: 'Não', value: '1' }]"
                />
              </b-form-group>
              <div
                v-if="chat.is_trigger === '1' || chat.is_trigger === 1 "
                class="form-group"
              >
                <label for="title">Uma url ou palavra:</label>
                <input
                  id="title"
                  v-model="chat.trigger"
                  type="text"
                  class="form-control"
                >
              </div>

              <h2 style="margin-top: 80px">
                Design do Chat
              </h2>
              <form
                style="margin-top: 20px;"
                @submit.prevent
              >
                <div class="form-group">
                  <label for="title-suporte-chat-fluxo">Título:</label>
                  <input
                    id="title-suporte-chat-fluxo"
                    v-model="design.title"
                    type="text"
                    class="form-control"
                  >
                </div>
                <b-form-group
                  id="posicao-chat-fluxo"
                  label="Posição:"
                >
                  <b-form-checkbox-group
                    v-model="design.side"
                    :checked="design.side"
                    value="1"
                    unchecked-value="0"
                    :options="[{ text: 'Esquerda', value: '0' }, { text: 'Direita', value: '1' }]"
                  />
                </b-form-group>
                <div class="form-group col-1">
                  <label for="cor-suporte-chat-fluxo">Cor:</label>
                  <input
                    id="cor-suporte-chat-fluxo"
                    v-model="design.color"
                    type="color"
                    class="form-control"
                  >
                </div>
                <div>
                  <span>Escolha seu Avatar:</span>
                </div>
                <div style="display:flex; gap: 10px;">
                  <div class="avatar-container">

                    <input
                      id="file-input"
                      type="file"
                      accept="image/*"
                      class="file-input"
                      @change="onFileChange($event)"
                    >
                    <label

                      for="file-input"
                      class="file-input-label"
                    >
                      <feather-icon
                        id="input-file-escolha-avatar-chat-fluxo"
                        size="5"
                        icon="PlusIcon"
                      />
                    </label>
                    <img
                      :src="design.avatar"
                      :style="{'opacity': imagemSelecionada ? '1' : '0.7'}"
                      class="avatar"
                    >
                  </div>
                  <div
                    id="avatares-escolha-chat-fluxo"
                    class="avatars col-9"
                    style="display:flex; flex-wrap: wrap; gap: 10px;"
                  >
                    <div
                      v-for="(avatar, index) in avatars"
                      v-if="index !== 0"
                      :key="index"
                      class="avatar-container"
                      style=" border-radius: 5px;"
                    >
                      <img
                        :src="avatar"
                        class="avatar"
                        :class="{ 'avatar-selecionado': avatar === imagemSelecionada }"
                        @click="selecionaImagem(avatar);"
                      >
                    </div>
                  </div>
                </div>
                <div class="fixed-button bg-light">
                  <button
                    id="btn-salvar-chat-fluxo"
                    class="btn btn-primary"
                    @click="atualizarChat(); atualizarDesign();"
                  >
                    Salvar Chat
                  </button>
                </div>
              </form>
            </b-card-text>
          </b-tab>
          <b-tab
            id="tab-fluxo-messagem-chat-fluxo"
            title="Fluxo de Mensagem"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'fluxo')"
          >
            <b-card-text>
              <FluxoMensagem />
            </b-card-text>
          </b-tab>
          <b-tab
            id="tab-integre-sistema-chat"
            title="Integre com Sistemas"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'integreSistema')"
          >
            <b-card-text>
              <IntegreSistema />
            </b-card-text>
          </b-tab>
        </b-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs, BTab, BFormGroup, BFormCheckboxGroup, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import IntegreSistema from '@/views/App/Chat/integreSistema.vue'
import FluxoMensagem from '@/views/App/Chat/FluxoMensagem.vue'
import { useApiAWS, useApi } from '@/composables/useApi'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import Info from './Info.vue'

const apiAws = useApiAWS()
const apiBack = useApi()

export default {

  components: {
    IntegreSistema,
    FluxoMensagem,
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    VBTooltip,
    Info,
    vSelect,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      dir: 'ltr',
      variaveis: [],
      condicao: ['é'],
      option: [],
      nextTodoId: 2,
      chamadaInicial: '',
      chatId: this.$route.query.id_chat,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      autoPlayer: '',
      imagemSelecionada: '',
      chat: [],
      design: [],
      avatars: [
        new Blob(), // Inicializa o primeiro elemento com um valor vazio de Blob
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Alberto.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ataliba.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Braga.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Bruna.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Elsa.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Franco.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Fred.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Harumi.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Kim.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Leopoldo.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Patricia.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Raquel.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Sakura.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Shin.webp',
        'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Silvia.webp',
      ],
    }
  },
  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    autoPlayerValue() {
      return this.autoPlayer ? 1 : 0
    },
    getDomainChateByRole: {
      get() {
        if (this.getUserData.user_role !== 'admin') {
          return this.getUserData.user_domain
        }
        return this.chat.domain
      },
      set(value) {
        this.chat.domain = value
      },
    },
  },
  watch: {

    getDomainChateByRole: {
      handler() {
        this.chat.domain = this.getDomainChateByRole
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'design')
    this.Listavariaveis()
    this.buscarInfoChat().then(() => {
      this.initTrHeight()
    })
  },

  created() {
    window.addEventListener('resize', this.initTrHeight, this.Listavariaveis)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },

  methods: {
    Listavariaveis() {
      apiBack.get(`/getFluxoEXTByIdFluxoAndOptions/${this.chatId}`)
        .then(response => {
          const resposta = JSON.parse(JSON.stringify(response.data))
          this.variaveis = resposta
            .filter(valor => valor.type === 2)
            .map(valor => ({
              id: valor.id,
              label: valor.label,
              options: JSON.parse(valor.options),
            }))
        })
        .catch(error => {
          console.error(error)
        })
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        variavel: {},
        condicao: 'é',
        valor: null,
        email: '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.formEmail.scrollHeight)
      })
    },
    mudarComponente() {
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB', {
        title: 'Gerenciar Fluxos',
        component: 'chat',
      })
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ params: {}, query: {} })
      }
    },
    buscarInfoChat() {
      const options = { method: 'GET' }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/chatInner/${this.chatId}`, options)
        .then(response => response.json())
        .then(response => {
          if (response.json[0].status === 'false') {
            this.autoPlayer = false
          } else {
            this.autoPlayer = response.json[0].status
          }
          if (JSON.parse(response.json[0].email_condicional) === null) {
            this.items = []
          } else {
            this.items = JSON.parse(response.json[0].email_condicional)
          }

          this.chat = response.json[0]
          this.design = response.json[0].design
        })
        .catch(err => console.error(err))
    },
    async updatedAvatarChat(url) {
      this.design.avatar = url
      await apiBack.put(`/chatd/${this.chatId}`, {
        avatar: url,
        color: this.design.color,
        side: this.design.side,
        subTitle: 'Online Agora',
        title: this.design.title,
      })
    },
    async uploadAvatarChat(file) {
      const formData = new FormData()
      formData.append('video', file)
      formData.append('caminho', `${this.getUserData.user_file_key}UploadImageChat/`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        this.design.avatar = response.data.data.fileUrl
        await this.updatedAvatarChat(response.data.data.fileUrl)
      }).catch(err => {
        console.log(err)
      })
    },
    async onFileChange(event) {
      const file = event.target.files[0]
      await this.uploadAvatarChat(file)
      const reader = new FileReader()
      reader.onload = () => {
        // Cria uma cópia do array `avatars` para evitar mutações diretas
        const avatarsCopy = [...this.avatars]
        avatarsCopy[0] = reader.result
        // Atualiza o valor de `avatars` com a cópia atualizada
        this.avatars = avatarsCopy
      }
      reader.readAsDataURL(file)
    },
    fluxo() {
      this.$router.push({ name: 'fluxoMensagem' })
    },
    updatedMessageInical(event) {
      this.chamadaInicial = JSON.parse(JSON.stringify(event))
    },
    async atualizarChat() {
      const urlSemProtocolo = this.chat.domain.replace(/^https?:\/\//, '')
      const posicaoBarra = urlSemProtocolo.indexOf('/')
      this.chat.domain = `${posicaoBarra === -1 ? urlSemProtocolo : urlSemProtocolo.slice(0, posicaoBarra)}`
      if (this.chat.is_trigger === 0) {
        this.chat.trigger = ''
      }
      await apiBack.put(`/chat/${this.chatId}`, {
        name: this.chat.name,
        chamadaInicial: this.chamadaInicial === '' ? this.chat.chamadaInicial : this.chamadaInicial,
        email_chat: this.chat.Email,
        triggerc: this.chat.trigger,
        is_trigger: this.chat.is_trigger,
        email_condicional: JSON.stringify(this.items),
        email_condicional_status: this.chat.email_condicional_status,
        status: this.autoPlayerValue,
        domain: this.chat.domain,
      })
    },
    async atualizarDesign() {
      await apiBack.put(`/chatd/${this.chatId}`, {
        avatar: this.design.avatar,
        color: this.design.color,
        side: this.design.side,
        subTitle: 'Online Agora',
        title: this.design.title,
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    selecionaImagem(avatar) {
      this.design.avatar = avatar
    },
    getValueBoolean(value) {
      return ['true', true, 1, '1'].indexOf(value) !== -1 ? 1 : 0
    },
    async changeStatus(chat) {
      chat.status = !this.getValueBoolean(chat.status)
      await apiBack.put(`/chat/${chat.id}`, { ...chat, status: this.getValueBoolean(chat.status) })
        .then(() => {
          this.listaChat()
        })
        .catch(err => console.error(err))
    },

  },

}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
.card {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.avatar-container {
  position: relative;
}

.file-input-label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
  cursor: pointer;
}

.file-input-label svg {
  width: 76px;
  height: 76px;
  position: absolute;
  top: 31px;
  stroke-width: 0.8;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 2;
}

.avatar {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.avatar:hover {
  border: 2px solid red;
}

.avatar-selecionado {
  border: 2px solid red;
}

.Scroll {
  height: 100px;
  overflow-y: scroll;

}

.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: #2e2e2f;
  transition: color .15s linear;
}

#texto {
  color: black;
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7px 11px;
  color: rgb(24 8 8 / 85%);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
.fixed-button {
  position: fixed;
  bottom: 20px; /* Ajuste o valor conforme necessário para posicionar o botão verticalmente */
  right: 20px; /* Ajuste o valor conforme necessário para posicionar o botão horizontalmente */
  z-index: 999; /* Certifique-se de que o botão esteja acima de outros elementos na página, se necessário */
}
</style>
